import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';
import 'zone.js/dist/zone-error';

export const theAshCustomerGroup = 'the_ash';
export const customerGroup = theAshCustomerGroup;

const supportEmail = {
	the_ash: 'the_ash@smoothr.de',
};
const firebaseConfig = {
	the_ash: {
		apiKey: 'AIzaSyDDScBLwIApVVe2sRymWdUXN1L1jQ_8bLE',
		authDomain: 'the-ash-web-app.firebaseapp.com',
		projectId: 'the-ash-web-app',
		storageBucket: 'the-ash-web-app.appspot.com',
		messagingSenderId: '886144071941',
		appId: '1:886144071941:web:653003ca5f5d0e688d5f6c',
		measurementId: 'G-08X1YTWEBR',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDYVbGtw-I6vLQcMLo3JQSti-zHqWvbsSw ',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	gaId: '',
	facebookPixel: '',
	urlQrCode: 'smoothr://',
};
